import React from 'react';
import { Link } from 'react-router-dom';
import theme from 'common/theme';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Typography from 'common/components/typography';
import { useSelector } from 'react-redux';
import { BoardBell } from 'common/components/svgs';
import { SoundFilled, RightOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import event from '~helpers/mixpanel';
import { handleTimeDuration, APITOKEN_TIME, DEPOSITE_TIME, COUNTEROFFER_TIME } from './common';
import useStyles from './style';
import { getSafeHtml } from 'common/helpers/safeHtml';
import { pageType } from '~constants/pages';

const ShowMoreModal = ({ visible, cancel, landlord }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  const pendingAt = landlord?.company?.pendingAt;

  const verifiedAt = landlord?.company?.verifiedAt;

  const { isPropertyLevel } = useSelector(state => ({
    isPropertyLevel: state.auth.getIn(['base', 'accountLevel']) === 'PROPERTY',
  }));

  let contentArr = [
    {
      key: 'pendingAtContent',
      contentType: 'News',
      content: {
        title: t('landlord.new_dashboard.broadcast.qualification_is_being_verified'),

        link: '/',
      },
      time: pendingAt,
    },
    {
      key: 'verifyAtContent',
      contentType: 'News',
      content: {
        title: t('landlord.new_dashboard.broadcast.qualification_is_verified'),
      },
      time: verifiedAt,
    },
    {
      key: 'apiTokenAtContent',
      contentType: 'Release',
      content: {
        title: t('landlord.new_dashboard.show_more.modal.api_token.title'),
        desc: t('landlord.new_dashboard.show_more.modal.api_token.desc'),

        link: '/help-center/api-token',
      },
      time: APITOKEN_TIME,
    },
    {
      key: 'paymentPlanAtContent',
      contentType: 'Release',
      content: {
        title: t('landlord.new_dashboard.show_more.modal.deposit_only.title'),
        desc: t('landlord.new_dashboard.show_more.modal.deposit_only.desc'),
        link: '/help-center/payment-plan',
      },
      time: DEPOSITE_TIME,
    },
    {
      key: 'counterOfferAtContent',
      contentType: 'Release',
      content: {
        title: t('landlord.new_dashboard.show_more.modal.counter_offer.title'),
        desc: t('landlord.new_dashboard.show_more.modal.counter_offer.desc'),
        link: '/help-center/counter-offer',
      },
      time: COUNTEROFFER_TIME,
    },
  ];
  const NewsEle = ({ time, title, link }) => {
    return (
      <If condition={time}>
        <div className={classes.release}>
          <div className={classNames(classes.iconBox, classes.iconGreen)}>
            <BoardBell width={16} height={16} />
          </div>

          <div className={classNames(classes.contentWrapper, classes.right)}>
            <div className={classes.contentWrapper}>
              <Typography
                className={classes.content}
                fontSize={14}
                lineHeight={22}
                themeColor={theme.colors.gray9}
              >
                <span>{getSafeHtml(title)}</span>
                <If condition={link}>
                  <Link to={link} target="_blank">
                    {t('landlord.new_dashboard.broadcast.view_business_info')}
                  </Link>
                </If>
              </Typography>
              <Typography
                className={classes.date}
                themeColor={theme.colors.gray7}
                fontSize={12}
                lineHeight={22}
              >
                {handleTimeDuration(time, t)}
              </Typography>
            </div>
          </div>
        </div>
      </If>
    );
  };

  const ReleaseEle = ({ title, desc, time, link }) => {
    return (
      <div className={classes.release}>
        <div className={classNames(classes.iconBox, classes.iconBlue)}>
          <SoundFilled className={classes.newIcon} />
        </div>

        <div className={classes.right}>
          <div className={classes.rightTop}>
            <span className={classes.funcTitle}>
              {t('landlord.new_dashboard.show_more.modal.func.release.title')}
            </span>
            <RightOutlined className={classes.rightIcon} />

            <span className={classes.funcDesc}>{getSafeHtml(title)}</span>
          </div>
          <div className={classes.contents}>
            <span className={classes.contentDesc}> {desc}</span>

            <span className={classNames(classes.learnMore, classes.toRight)}>
              <Link
                to={link}
                target="_blank"
                onClick={() => {
                  handleEvent('Learn More');
                  event('Viewed News in Help Center Page', {
                    'Auth Method': 'News Feed Page',
                    'Current Page Type': pageType.dashboard,
                  });
                }}
              >
                {t('landlord.new_dashboard.broadcast.learn_more')}
              </Link>
            </span>
          </div>
          <div className={classes.time}> {handleTimeDuration(time, t)}</div>
        </div>
      </div>
    );
  };
  const sortContent = arr => {
    const computeTimeStamp = arr => {
      arr.forEach(item => {
        item.timeStamp = item.time ? new Date(item.time).getTime() : 0;
      });
      return arr;
    };
    const deleteApiToken = arr => {
      const index = arr.findIndex(i => i.key === 'apiTokenAtContent');
      arr.splice(index, 1);
      return arr;
    };
    const sortByTimeStamp = arr => {
      return arr.sort((a, b) => b.timeStamp - a.timeStamp);
    };

    let newContentArr = computeTimeStamp(arr);
    if (isPropertyLevel) {
      newContentArr = deleteApiToken(newContentArr);
    }
    return sortByTimeStamp(newContentArr);
  };

  const contents = sortContent(contentArr);
  const handleEvent = value => {
    event('Clicked News Feed Btn', {
      'Clicked Position': value,
      'Current Page Type': pageType.dashboard,
    });
  };
  return (
    <Modal
      className={classes.modal}
      centered
      title=""
      visible={visible}
      footer={null}
      onCancel={() => {
        handleEvent('Close');
        cancel();
      }}
    >
      <h2 className={classes.modalTitle}> {t('landlord.new_dashboard.broadcast.title')}</h2>

      <For each="item" of={contents} index="index">
        <If condition={item.contentType === 'News'}>
          <NewsEle {...item.content} time={item.time} />
        </If>
        <If condition={item.contentType === 'Release'}>
          <ReleaseEle {...item.content} time={item.time} />
        </If>
      </For>
    </Modal>
  );
};
export default ShowMoreModal;
